module.exports = __webpack_public_path__ + "img/11.ed7b4cd8.jpg";